// extracted by css-extract-rspack-plugin
export default {"body":"FeedbackDialog-module__body__LaKrF","intro":"FeedbackDialog-module__intro__NspPm","textarea":"FeedbackDialog-module__textarea__kvqcu"};